import { useFormik } from 'formik';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { Toast } from 'primereact/toast';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { VendersContext } from '../../context/Store';
import { GetData, PostData, apiheader } from '../../utils/fetchData';



const AddCategories = () => {
  let { isLang } = useContext(VendersContext);
  const url = `${process.env.REACT_APP_API_URL}/categories`;
  const [loading, setLoading] = useState(false);
  const [parentId, setParentId] = useState([]);
  const toast = useRef(null);
  let navigate = useNavigate()
  const items = [
    { label: <Link to={'/categories'}>{isLang === "en" ? "Categories  " : 'الأقسام'}  </Link> },
    { label: <Link to={'/categories/add'} className='bg-orange-100 p-2 border-round'>  {isLang === "en" ? "New categories  " : 'إضافة  قســم جديد'} </Link> }
  ];

  const home = { icon: 'pi pi-home', url: '/' };
  const formik = useFormik({
    initialValues: {
      name_en: '',
      name_ar: '',
      parent_id: '',
    },
    onSubmit: async (values, { resetForm }) => {
      console.log(values);
      try {

        setLoading(true);
        let { data } = await PostData(url, values, apiheader);
        console.log(data);
        if (data?.status === 200) {
          toast.current.show({ severity: 'success', summary: 'Success', detail: data?.message, life: 3000 });
          setTimeout(() => {
            setLoading(false);
            navigate('/categories')
            resetForm();
          }, 1000);
        } else if (data?.status === 400) {
          toast.current.show({ severity: 'warn', summary: 'Warn', detail: data?.message, life: 3000 });
          resetForm();
          setLoading(false);
        } else {
          toast.current.show({ severity: 'error', summary: 'Error', detail: data?.message, life: 3000 });
        }

      } catch ({ response }) {
        console.error(response.data.message);
        toast.current.show({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 });
        setLoading(false);
      }
    }
  });
  const fetchParentIdData = async () => {
    const url = `${process.env.REACT_APP_API_URL}/categories/get/parent-categories`;
    let data = await GetData(url, apiheader);
    setParentId(data?.data);
    console.log(data?.data);
  }
  useEffect(() => {
    fetchParentIdData();
  }, [])
  return (
    <div>
      <Toast ref={toast} position={isLang === "en" ? 'top-right' : 'top-left'} />

      <BreadCrumb model={items} home={home} />
      <form onSubmit={formik.handleSubmit} className='mt-6 w-11  m-auto'>

        <div className="grid  mt-5  ">
          <div className="lg:col-6 md:col-12 sm:col-12 mt-2 input__Col ">
            <label htmlFor="name_en" className="font-bold block mb-2"> {isLang === "en" ? "Categories name (En)" : ' اسم القســم  (En)'}   </label>
            <InputText name='name_en' id="name_en" keyfilter="text" className="w-full  p-inputtext-sm" onChange={formik.handleChange}
              onBlur={formik.handleBlur} />
          </div>
          <div className="lg:col-6 md:col-12 sm:col-12   mt-2 input__Col" >
            <label htmlFor="name_ar" className="font-bold block mb-2">  {isLang === "en" ? "Categories name (En)" : ' اسم القســم  (Ar)'}  </label>
            <InputText name='name_ar' id="name_ar" keyfilter="text" className="w-full  p-inputtext-sm" dir='rtl' onChange={formik.handleChange}
              onBlur={formik.handleBlur} />
          </div>
        </div>
        <div className="grid  mt-5  ">
          <div className="lg:col-6 md:col-12 sm:col-12 mt-2 input__Col ">
            <label htmlFor="parent_id" className="font-bold block mb-2">  {isLang === "en" ? "categorie " : '   حدد القسم '}    </label>
            <Dropdown
              options={parentId?.map(item => ({
                name: isLang === "en" ? item?.name_en : item?.name_ar,
                value: item.id,
              }))}
              filter
              id="parent_id"
              name="parent_id"
              optionLabel="name"
              optionValue="value"
              value={formik.values.parent_id} // Add this line 
              onChange={(e) => formik.setFieldValue("parent_id", e.value)}
              onBlur={formik.handleBlur}
              placeholder={isLang === "en" ? 'Select a parent_id' : 'اختر '}
              className="w-full p-inputtext-sm"
            />

          </div>
        </div>

        <div className="btn_gapAr  group flex justify-content-center gap-4 ">
          <Button icon="pi pi-check" loading={loading} label={isLang == "en" ? 'Submit' : 'إرسال  '} type="submit" size='small' className='mt-3' />
          <Link to={'/categories'}>
            <Button label={isLang == "en" ? 'Cancel' : 'إلغاء  '} type="reset" outlined size='small' className='mt-3' />
          </Link>
        </div>
      </form>
    </div>
  );
};

export default AddCategories
